<script>
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'TaskSortChangePopup',
  controller: null,
  components: { BasePopup },
  props: {
    tasks: Array,
  },
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    sortByName(isAsc) { this.sort((a, b) => a.name.localeCompare(b.name), isAsc); },
    sortByPriority(isAsc) { this.sort((a, b) => (a.priority - b.priority), isAsc); },
    sortById(isAsc) { this.sort((a, b) => a.id - b.id, isAsc); },
    sortByDateFinish(isAsc) { this.sort((a, b) => new Date(a.dateFinish) - new Date(b.dateFinish), isAsc); },
    sort(sorter, isAsc) {
      const result = [...this.tasks].sort((a, b) => sorter(a, b) * (isAsc ? 1 : -1));
      this.resolve(result);
    },
    open() {
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      this.$options.controller.resolve(null);
    },
    resolve(result) {
      this.isOpened = false;
      this.$options.controller.resolve(result);
    },
  },
};
</script>

<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened")
    .b-task-sort-change-popup
      ._warn Вы собираетесь пересортировать задачи. Это действие невозможно отменить.
      ._buttons
        Btn(green @click="sortByName(true)") По алфавиту по возрастанию
        Btn(green @click="sortByName(false)") По алфавиту по убыванию
        Btn(green @click="sortByPriority(true)") По приоритету по возрастанию
        Btn(green @click="sortByPriority(false)") По приоритету по убыванию
        Btn(green @click="sortById(true)") По дате создания по возрастанию
        Btn(green @click="sortById(false)") По дате создания по убыванию
        Btn(green @click="sortByDateFinish(true)") По дате завершения по возрастанию
        Btn(green @click="sortByDateFinish(false)") По дате завершения по убыванию
</template>

<style scoped lang="scss">
.task-sort-change-popup {
  &__warn {
    text-align: center;
    margin-bottom: 30px;
  }

  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 20px;
    column-gap: 10px;
  }

  @media (max-width: 992px) {
    &__buttons {
      grid-template-columns: 1fr;
    }
  }
}
</style>
